module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "aubiof"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "piv"
    }
  }), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JAMES")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("N.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("DRUCKMAN")]), _vm._v(" is the Payson S. Wild Professor of Political Science and Faculty Fellow at the Institute for Policy Research at Northwestern University and an honorary professor of political science at Aarhus University in Denmark.")]), _vm._v(" "), _c('p', {
    staticClass: "aubiof"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("LAWRENCE")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("R.")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("JACOBS")]), _vm._v(" is the Walter F. and Joan Mondale Chair for Political Studies at the Humphery School of Public Affairs and the Department of Political Science at the University of Minnesota.")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("The University of Chicago Press, Chicago 60637")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("The University of Chicago Press, Ltd., London")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("© 2015 by The University of Chicago")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved. Published 2015")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("Printed in the United States of America")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("24 23 22 21 20 19 18 17 16 15  1 2 3 4 5")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-23438-0 (cloth)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-23441-0 (paper)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v("-13: 978-0-226-23455-7 (e-book)")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("DOI")]), _vm._v(": 10.7208/chicago/9780226234557.001.0001")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Druckman, James N., 1971– author.")]), _vm._v(" "), _c('p', {
    staticClass: "cip1"
  }, [_vm._v(" Who governs? : presidents, public opinion, and manipulation / James N. Druckman and Lawrence R. Jacobs.")]), _vm._v(" "), _c('p', {
    staticClass: "cip2"
  }, [_vm._v("   pages cm — (Chicago studies in American politics)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-23438-0 (cloth : alk. paper) — "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-23441-0 (pbk. : alk. paper) — "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ISBN")]), _vm._v(" 978-0-226-23455-7 (e-book) 1. Presidents — United States. 2. Democracy—United States. 3. Public opinion—United States. 4. United States—Politics and government. I. Jacobs, Lawrence R., author. II. Title. III. Series: Chicago studies in American politics.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_c('span', {
    staticClass: "sm"
  }, [_vm._v("JK")]), _vm._v("516."), _c('span', {
    staticClass: "sm"
  }, [_vm._v("D")]), _vm._v("793 2015")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("320.973 — dc23")]), _vm._v(" "), _c('p', {
    staticClass: "cipl"
  }, [_vm._v("\t2014026787")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_vm._v("♾ This paper meets the requirements of "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("ANSI/NISO")]), _vm._v(" "), _c('span', {
    staticClass: "sm"
  }, [_vm._v("Z")]), _vm._v("39.48-1992 (Permanence of Paper).")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35dc3c08","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-druckman-jacobs-0005.vue
// module id = 66
// module chunks = 0